import React from 'react';
import {GroupItems} from "components/pages/groups/group-table/group-items/GroupItems";
import {Pagination} from "../../../layout/pagination/Pagination";
import {useAppDispatch, useAppSelector} from "common/hook";
import {setGroupsCurrentPage} from "features/model/slice/groups/groupsSlice";
import {Group} from "features/model/types/groups/groupsSchema";
import {Preloader} from "../../../layout/preloader/Preloader";
import {NothingYetMessage} from "../../personal-cabinet/nothing-yet-message/NothingYetMessage";


export const GroupTable = () => {
    const dispatch = useAppDispatch();
    const groupsState = useAppSelector((state) => state.groups);

    const {groups, currentPage, pageSize, totalItems, isLoading} = groupsState;

// Сделать пагинацию

    const paginate = (pageNumber: number) => {
        dispatch(setGroupsCurrentPage(pageNumber));
    };


    const startIndex = currentPage * pageSize;
    const endIndex = startIndex + pageSize;
    const currentGroups = groups.slice(startIndex, endIndex);


    return (
        <div className="data-tbl groups-tbl">
            <div className="row thead">
                <div className="col group-name-col">Название группы</div>
                <div className="col level-col">Уровень</div>
                <div className="col students-col">Студенты</div>
                <div className="col company-col">Компания</div>
            </div>


            {isLoading ? (
                <Preloader />
            ) : (
                currentGroups && currentGroups.length > 0 ? (
                    currentGroups.map((group: Group) => (
                        <GroupItems group={group} key={group.id} />
                    ))
                ) : (
                    <NothingYetMessage />
                )
            )}


            {totalItems > pageSize && (
                <Pagination
                    paginate={paginate}
                    currentPage={currentPage}
                    totalItems={totalItems}
                    itemsPerPage={pageSize}
                />
            )}

        </div>
    );
};

